<template>
  <th>
    <slot />
    <i
      :class="{ 'material-icons': true, 'is-desc': true, 'is-active': column === field && direction === 'DESC', 'ml-2': true }"
      @click="setOrdering(field, 'DESC')">
      filter_list
    </i>
    <i
      :class="{ 'material-icons': true, 'is-asc': true, 'is-active': column === field && direction === 'ASC', 'ml-1': true }"
      @click="setOrdering(field, 'ASC')">
      filter_list
    </i>
  </th>
</template>

<script>
export default {
  name: 'sortable-table-heading',
  props: [
    'field',
    'view',
    'column',
    'direction'
  ],
  methods: {
    setOrdering (column, direction) {
      window.localStorage.setItem('crm-ordering-' + this.view + '-column', column);
      window.localStorage.setItem('crm-ordering-' + this.view + '-direction', direction);
      this.$bus.$emit('table-ordering-change', column, direction);
    }
  }
}
</script>

<style lang="scss" scoped>
.is-desc,
.is-asc {
  color: var(--secondary);
  cursor: pointer;
  opacity: .5;
  transform: scale(1.2);

  &.is-active {
    color: var(--primary);
    opacity: 1;
  }
}

.is-asc {
  transform: scale(1.2) rotate(180deg);
}
</style>
